import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "./AdminLogin.css";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();

    if (email === "Doradmin@gmail.com" && password === "Sairam@7007") {
      localStorage.setItem("adminAuth", "true");
      navigate("/admin");
    } else {
      alert("Invalid credentials");
    }
  };

  return (
    <div className="admin-login-container">
      <Helmet>
        <title>Admin Login | DOR Dress On Rent</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <form className="admin-login-card" onSubmit={handleLogin}>
        <h2 className="admin-login-title">Admin Login</h2>

        <input
          type="email"
          placeholder="Admin Email"
          className="admin-input"
          value={email}
          onChange={(e)=>setEmail(e.target.value)}
        />

        <input
          type="password"
          placeholder="Password"
          className="admin-input"
          value={password}
          onChange={(e)=>setPassword(e.target.value)}
        />

        <button className="admin-login-btn" type="submit">
          Login
        </button>

        <div className="admin-login-footer">
          Secure Admin Panel
        </div>
      </form>
    </div>
  );
};

export default AdminLogin;